// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from '../src/store/index';
import directive from '../src/common/directive';
import component from '@/common/component';
import filter from '@/common/filter';
// 国际化 internationalization
// import i18n from './i18n';
// import i18n from './i18n/';
// AOS动画效果
import AOS from 'aos'
import 'aos/dist/aos.css'
import Element from 'element-ui';
import '../src/assets/fonts/quill.css';
import 'element-ui/lib/theme-chalk/index.css'
import '../src/assets/stylus/index.styl';
import '../src/assets/stylus/color.styl';
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
// import component from '@/common/component';
import 'font-awesome/css/font-awesome.css';
// 视频播放器
import VideoPlayer from 'vue-video-player';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import 'vue-video-player/src/custom-theme.css';
// viewer图片在线预览
import 'viewerjs/dist/viewer.min.js';
import 'viewerjs/dist/viewer.min.css';
// vue 拖拽组件
import vuedraggable from 'vuedraggable';
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'
import VueDraggableResizable from 'vue-draggable-resizable'
// 引入 vue-quill-editor
import QuillEditor from 'vue-quill-editor'
import * as Quill from 'quill'
import imageResize from 'quill-image-resize-module'
// ueditor组件
import '../static/plugins/ueditor/ueditor.config.js';
import '../static/plugins/ueditor/ueditor.all.js';
import '../static/plugins/ueditor/lang/zh-cn/zh-cn.js';
import '../static/plugins/ueditor/ueditor.parse.min.js'
// 按需引入Echarts
import ECharts from 'vue-echarts/components/ECharts.vue';
import 'echarts/lib/chart/pie';
import 'echarts/lib/chart/bar';
import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/legend';
import 'echarts/lib/chart/line'
// 富文本组件
import Editor from '@/components/Editor'
// 补丁，m3u8视频原插件不支持，需引入以下内容
// 引入i18n
// import VueI18n from 'vue-i18n'
window.videojs = videojs;
require('videojs-contrib-hls/dist/videojs-contrib-hls.js');
require('es6-promise').polyfill()
Vue.component('chart', ECharts);
Vue.component('vuedraggable', vuedraggable);
Vue.component('vue-draggable-resizable', VueDraggableResizable)
Quill.register('modules/imageResize', imageResize)
Vue.config.productionTip = false
Vue.use(Element);
// Vue.use(component);
Vue.use(vuedraggable);
Vue.use(directive);
Vue.use(component);
Vue.use(QuillEditor);
Vue.use(filter);
Vue.component('Editor', Editor)
// Vue.use(VueI18n)
// const i18n = new VueI18n({
//   locale: 'zh-CN',
//   messages: {
//     'zh-CN': require('@/common/lang/zh'),
//     'en-US': require('@/common/lang/en')
//   }
// })
/* eslint-disable no-new */
Vue.use(VideoPlayer);
AOS.init();
// 跳转后返回顶部
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
})
new Vue({
  store,
  router,
  // i18n,
  components: {
    App
  },
  template: '<App/>'
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js